// export { default as Impact } from './impact';
import { useFlags } from 'launchdarkly-react-client-sdk';

import ImpactForm from './impact';
import ImpactFormNew, { Props } from './impactNew';

export const Impact = ({ closeModal, clientId }: Props) => {
  const { enableDateTimeUpdates } = useFlags();

  return enableDateTimeUpdates ? (
    <ImpactFormNew closeModal={closeModal} clientId={clientId} />
  ) : (
    <ImpactForm closeModal={closeModal} clientId={clientId} />
  );
};
